module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-9.7d7efbbb.png";